import gql from 'graphql-tag';
import {
	SHOP_MENU_UPDATE_START,
	SHOP_MENU_UPDATE_SUCCESS,
	SHOP_MENU_UPDATE_ERROR
} from '../../../constants/index';
import { toastr } from 'react-redux-toastr';
import { loadAccount } from '../userAccount/userAccount';

const query = gql`
query($currentPage: Int, $searchList: String, $menuId: Int) {
	getAllSubMenu(currentPage: $currentPage, searchList: $searchList, menuId: $menuId){
	  status
	  errorMessage
	  menuName
	  results {
		id
		shopId
		menuId
		name
		isEnable
		item {
			id
			subMenuId
			menuId
			itemName
			itemDescription
			price
			tax
			image
			itemType
			isEnable
			discountType
			discountValue
			shopTaxAndFee {
				serviceFee
				totalTax
				taxCalculationType
			}
			shopTax
		}
	  }
	}  
  }
`;

export default function moveItem(id, subMenuId, targetMenuId, currentPage, menuId) {
	return async (dispatch, getState, { client }) => {
		dispatch({
			type: SHOP_MENU_UPDATE_START,
			payload: {
				updateLoading: true
			}
		});

		try {
			let errorMessage;

			const mutation = gql`
            mutation moveItem($id: Int, $subMenuId: Int, $targetMenuId: Int) {
				moveItem(id: $id, subMenuId: $subMenuId, targetMenuId: $targetMenuId) {
					status
					errorMessage
				}
			}
            `;

			const { data } = await client.mutate({
				mutation,
				variables: {
					id,
					subMenuId,
					targetMenuId
				},
				refetchQueries: [{ query, variables: { currentPage, searchList: '', menuId } }]
			});

			if (data && data.moveItem && data.moveItem.status === 200) {
				dispatch({
					type: SHOP_MENU_UPDATE_SUCCESS,
					payload: {
						updateLoading: false
					}
				});
				toastr.success('Success', `The Item has been moved successfully.`);
				dispatch(loadAccount());
			} else {
				dispatch({
					type: SHOP_MENU_UPDATE_ERROR,
					payload: {
						updateLoading: false
					}
				});

				errorMessage = (data && data.moveItem && data.moveItem.errorMessage) || "Oops! Something went wrong. Please try again.";
				toastr.error('Error!', errorMessage);
			}
		} catch (err) {
			toastr.error('Error!', err.message || 'Something went wrong');
			dispatch({
				type: SHOP_MENU_UPDATE_ERROR,
				payload: {
					updateLoading: false
				}
			});
		}
	}
};
